export const SET_ERRORS = "SET_ERRORS";
export const RESET = "RESET";

export const SET_TOTAL_PAGES = "SET_TOTAL_PAGES";
export const SET_PAGE = "SET_PAGE";
export const SET_SEARCH = "SET_SEARCH";
export const SET_LIMIT = "SET_LIMIT";
export const SET_FILTERS = "SET_FILTERS";
export const SET_ORDERS = "SET_ORDERS";
export const SET_DOCUMENT = "SET_DOCUMENT";
export const SET_DOCUMENT_LOADING = "SET_DOCUMENT_LOADING";

export const SET_CREATE_MODAL = "SET_CREATE_MODAL";
export const SET_EDIT_MODAL = "SET_EDIT_MODAL";
export const SET_ALERT_MODAL = "SET_ALERT_MODAL";
export const SET_SHOW_MODAL = "SET_SHOW_MODAL";

export const SET_LOADING = "SET_LOADING";
export const SET_AXIOS_ERROR = "SET_AXIOS_ERROR";
export const SET_SNACKBAR = "SET_SNACKBAR";

export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";

export const SET_ROLES = "SET_ROLES";
export const SET_USER_ROLE = "SET_USER_ROLE";

export const SET_USER = "SET_USER";
export const SET_LOGGED_IN = "SET_LOGGED_IN";

export const SET_ITEM = "SET_ITEM";
export const SET_CALLBACK = "SET_CALLBACK";
export const SET_MODULE = "SET_MODULE";

export const SET_ACTIVITIES = "SET_ACTIVITIES";
export const SET_ACTIVITY = "SET_ACTIVITY";
export const SET_ACTIVITIES_MODAL = "SET_ACTIVITIES_MODAL";

export const SET_GAZETTES = "SET_GAZETTES";
export const SET_GAZETTE = "SET_GAZETTE";
export const SET_GAZETTE_MODAL = "SET_GAZETTE_MODAL";
export const RETRIEVE_CHANGE_FORM_SERVER = "RETRIEVE_CHANGE_FORM_SERVER";
